import React from 'react';
import getStore from 'store/store';
import { defaultFallbackInView } from 'react-intersection-observer';
import { createRoot } from 'react-dom/client';
import { AppConfiguration } from 'core/configuration/AppConfiguration';
import { Provider } from 'react-redux';
import { getMessagingClientLibraryUrl } from 'core/messaging/ActivitiesMessagingClient';

// TODO: Find ways to remove relative imports
// eslint-disable-next-line import/order,no-restricted-imports
import App from './App';

defaultFallbackInView(true);

const loadMockData = async () => {
    const initMockData = await import('./mock/import-mock-data');

    if (initMockData) {
        if ('default' in initMockData) {
            // fallback for webpack
            initMockData.default();
        } else {
            const initMockDataFn = initMockData as unknown;
            if (typeof initMockDataFn === 'function') {
                initMockDataFn();
            } else {
                // eslint-disable-next-line no-restricted-syntax
                console.warn('Could not load mock data.', initMockData);
            }
        }
    }
};

export const renderApp = async (mountPoint: HTMLElement | null) => {
    if (AppConfiguration.isMock()) {
        await loadMockData();
    }

    // Don't Remove this - Calling explicitly to getMessagingClientLibraryUrl to initialize the messaging client
    getMessagingClientLibraryUrl('', '');

    // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
    const root = createRoot(mountPoint || document.getElementById('app')!);
    root.render(
        <Provider store={getStore()}>
            <App />
        </Provider>,
    );
};

// Fix ESLint error for unhandled Promise
// eslint-disable-next-line no-void
void renderApp(null);
